
export class TransactionReportOutput {
    transactionsNumber: number;
    transactionsAmount: number = 0;
    mapValues: Map<string, any>;
}